
export default [{
  name: 'error404',
  path: '*',
  component: require('@/pages/error/404.vue').default,
  meta: {
    layout: 'LegacyLayout'
  }
}]
